import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Modal } from 'semantic-ui-react'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validation, validateCase as vCase } from 'core/validate'
import Approvers from 'routes/ProcurementSystem/Shared/DocumentStep/Approvers'
import ActionCommentModal from './ActionCommentModal'
import { billFormPath, billCoverPath } from 'routes'
import { MainBodyContent, StatusTag } from 'components'
import Information from '../From/Information'
import CommentHistory from '../Detail/CommentHistory'
import { showModal, } from 'ducks/app'
import {
  getGRRelease,
  initializeBL,
  updateBillform,
  getBLErrorWorkFlow,
  BLAction,
  createBL,
  getBillformDetail,
  clearBLDetail,
  deleteBL
} from 'ducks/billform'
import { BottomActionsContainer } from './styled'
import { acceptMessage, haveTypeGoods } from '../billingHelper'

// import r from 'reactotron-react-js'

const EditBilling = props => {
  const { history, change, approvers, valueForm, blDetail, isDetail = false } = props
  const blStatus = { 0: 'Draft', 2: 'In Progress', 3: 'Revise', 4: 'Completed', 5: 'Reject', 6: 'Cancelled' }

  const [actionName, setActionName] = React.useState('')
  const [showDialogComment, setShowDialogComment] = React.useState(false)
  const [showAcceptModal, setShowAcceptModal] = useState(false)
  const [blId, setBlId] = useState(0)

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0, 0)
    if (match && match.params && match.params.blId) {
      props.initializeBL(isDetail)
      props.getBillformDetail(match.params.blId, history, true)
    }
    return (() => {
      props.clearBLDetail()
    })
  }, [])

  React.useEffect(() => {
    if (Object.keys(blDetail).length) {
      let grNum = ''
      blDetail.searchGoodsServiceReceipt.forEach((x, i) => {
        if (i === 0) {
          grNum += x
        } else {
          grNum += `,${x}`
        }
      })
      props.getGRRelease({ grID: grNum })
    }
  }, [blDetail])

  React.useEffect(() => {
    if (valueForm.status && valueForm.status !== 0) {
      props.getBLErrorWorkFlow(valueForm.procInstId, valueForm.subProcInstId)
    }
  }, [valueForm.status])

  const onSubmitSuccess = (id) => {
    setBlId(id)
    setShowAcceptModal(true)
  }

  const onSubmitForm = () => {
    if (['Delete', 'Cancel', 'Revise'].indexOf(actionName) >= 0) {
      if (actionName === 'Delete') {
        props.deleteBL({
          docId: valueForm.id,
        }, history)
      } else if (actionName === 'Cancel') {
        props.BLAction({
          docId: valueForm.id,
          sn: valueForm.sn,
          action: 'Cancel',
          comment: valueForm.actionComment
        }, history)
      } else if (actionName === 'Revise') {
        props.BLAction({
          docId: valueForm.id,
          sn: valueForm.sn,
          action: 'Revise',
          comment: valueForm.actionComment
        }, history)
      }
    } else {
      const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
      return sleep(100)
        .then(() => {
          let errors = validateField(valueForm, actionName)
          if (Object.keys(errors).length) {
            scrollToFirstValidateFailElement(errors)
            throw new SubmissionError(errors)
          } else {
            if (actionName === 'save') {
              props.updateBillform(valueForm, history, false)
            } else if (actionName === 'submit') {
              props.updateBillform(valueForm, history, true, onSubmitSuccess)
            } else if (actionName === 'resubmit') {
              props.updateBillform(valueForm, history, true, onSubmitSuccess)
            }
          }
          setShowDialogComment(false)
        })
    }
  }

  const validateField = (values, actionName = null) => {
    let errors = {}
    if (actionName === 'Delete') {
      return errors
    } else if (actionName === 'Cancel' || actionName === 'Revise') {
      if (!values.actionComment) {
        errors.actionComment = 'Required!'
      }
    } else {
      if (!values.title) {
        errors.title = 'Required!'
      }
      if (values.title && values.title.length > 200) {
        errors.title = 'Title must be less than or equal to 200 characters'
      }
      if (!values.requesterUser) {
        errors.requesterUser = 'Required!'
      }
    }
    return errors
  }

  return (
    <MainBodyContent
      accessoriesHeader={
        <React.Fragment>
          <Approvers
            approvers={approvers.data}
            status={valueForm.status}
            trigger={
              <Button
                basic
                circular
                type='button'
                loading={approvers.loading}
                content='View Approver'
                headerTitle={<React.Fragment>{`Billing- Edit ${blDetail ? blDetail.documentNumber ? `#${blDetail.documentNumber}` : '' : ''}`}<span style={{ width: '1rem' }} />{blDetail && <StatusTag isBilling status={blDetail && blDetail.status} statusName={blStatus[blDetail ? blDetail.status : 0]} />}</React.Fragment>}
                labelPosition='right'
                icon='sort numeric down' />
            }
          />
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            {
              key: 'BL',
              content: 'Billing',
              link: true,
              onClick: () => history.push(billFormPath),
            },
            { key: 'BLEdit', content: 'Edit', active: true },
          ]}
        />
      }
    >
      {/* <Button
        content='test accept modal'
        onClick={() => setShowAcceptModal(true)}
      /> */}
      <Information isCreate={false} isEdit={true} change={change} />
      <div style={{ marginTop: '1rem' }} />
      {blDetail && blDetail.id && <CommentHistory blDetail={blDetail} />}
      <form onSubmit={props.handleSubmit(() => onSubmitForm())}>
        <BottomActionsContainer>
          <Button
            type='submit'
            content='Save'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '0.3125rem' }}
            onClick={() => setActionName('save')}
          />
          {valueForm.status === 1 ?
            <Button
              type='button'
              content='Save & Re-Submit'
              color='blue'
              icon='save'
              labelPosition='right'
              style={{ marginRight: '0.3125rem' }}
              onClick={() => {
                setShowDialogComment(true)
                setActionName('resubmit')
              }}
            />
            :
            <Button
              type='submit'
              content='Save & Submit'
              color='blue'
              icon='save'
              labelPosition='right'
              style={{ marginRight: '0.3125rem' }}
              onClick={() => setActionName('submit')}
            />
          }
          {valueForm.status === 0 ?
            <Button
              type='button'
              content='Delete'
              color='red'
              style={{ marginRight: '0.3125rem' }}
              onClick={() => {
                setShowDialogComment(true)
                setActionName('Delete')
              }}
            />
            :
            <Button
              type='button'
              content='Cancel'
              color='orange'
              style={{ marginRight: '0.3125rem' }}
              onClick={() => {
                setShowDialogComment(true)
                setActionName('Cancel')
              }}
            />
          }
        </BottomActionsContainer>
      </form>
      {showDialogComment && <ActionCommentModal submit={props.handleSubmit(() => onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={actionName} />}
      <Modal
        open={showAcceptModal}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        {acceptMessage(valueForm.ivSelected || [], 'en')}
        <Modal.Actions>
          <Button
            content='Accept'
            labelPosition='right'
            icon='checkmark'
            onClick={() => {
              setShowAcceptModal(false)
              if (haveTypeGoods(valueForm.ivSelected || [])) {
                history.push(billCoverPath(blId))
              } else {
                history.push(billFormPath)
              }
            }}
          />
        </Modal.Actions>
      </Modal>
    </MainBodyContent>
  )

}

const validate = values => {
  let errors = {}
  errors = validation(values, 'title', [vCase.maxLength200], errors)
  errors = validation(values, 'invoiceNumber', [vCase.maxLength25], errors)

  return errors
}

const mapStateToProps = (state, props) => {
  let blDetail = state.billform.billformDetail
  return ({
    initialValues: {
      ...blDetail.data,
      start: true
    },
    blDetail: blDetail.data || {},
    approvers: state.billform.approvers,
    valueForm: getFormValues('formBL')(state) || {},
  })
}
const mapDispatchToProps = {
  getBLErrorWorkFlow,
  getBillformDetail,
  initializeBL,
  getGRRelease,
  createBL,
  deleteBL,
  updateBillform,
  clearBLDetail,
  BLAction,
  showModal,
}

const EditBillingForm = reduxForm({
  form: 'formBL',
  enableReinitialize: true,
  validate
})(EditBilling)

export default connect(mapStateToProps, mapDispatchToProps)(EditBillingForm)
